import { Button, Link, Stack } from "@mui/material";
import React from "react";
import { ManualDispatchCardItem } from "tng-address-collection-shared/types/apiTypes.ts";
import { useToggleCardManuallySent } from "../hooks/useToggleCardManuallySent.ts";
import { useTranslator } from "../i18n/translator.ts";

const ManualDispatchActions = ({ card }: { card: ManualDispatchCardItem }) => {
  const translator = useTranslator();
  const isSent = card.manuallySentAt !== null;
  const { mutate: toggleCardManuallySent, isPending } =
    useToggleCardManuallySent({
      cardId: card.id,
      projectId: card.projectId,
    });
  const href = `mailto:${card.email ?? ""}?subject=${encodeURIComponent(
    card.subject,
  )}&body=${encodeURIComponent(card.body)}`;

  return (
    <Stack direction="row" spacing={1} justifyContent="flex-end">
      <Button
        component={Link}
        href={href}
        rel="noopener noreferrer"
        target="_top"
        size="small"
        disabled={isPending}
      >
        {translator("manualDispatchSendMail")}
      </Button>
      <Button
        size="small"
        disabled={isPending}
        loading={isPending}
        onClick={() => toggleCardManuallySent(isSent)}
      >
        {translator(
          isSent ? "manualDispatchMarkUnsent" : "manualDispatchMarkSent",
        )}
      </Button>
    </Stack>
  );
};

export const MemoManualDispatchActions = React.memo(ManualDispatchActions);
